// Copyright 2021-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import AlertGroup from "./AlertGroup";

export default AlertGroup;
